import { oktaGet } from '../oktaRequestWrapper';
import { ApiRoutes } from '../apiRoutes';

export const getInvoicesSummary = async (signal?: AbortSignal) => {
  const requestConfig = {
    headers: {
      'api-version': '2.0',
    },
    signal, // Pass abort signal to axios
  };

  const response = await oktaGet(ApiRoutes.InvoicesSummary, requestConfig);
  return response.data;
};